const EVENT_TYPE = {
  ON_MESSAGE_CHUNK: "message_chunk",
  ON_MESSAGE: "message",
  ON_CURRENT_TOOL_USE: "current_tool_use",
  GENERIC_EVENT: "event",
};
const URL = `https://bedrock-agentcore.ap-southeast-2.amazonaws.com/runtimes/{{escapedAgentArn}}/invocations?qualifier=DEFAULT`;
const ARN =
  "arn:aws:bedrock-agentcore:ap-southeast-2:639989371409:runtime/ask_teamform-USGr7zFhQR";

const streamAIResponse = async (
  params,
  {
    onMessageStart,
    onMessage,
    onMessageChunk,
    onCurrentToolUse,
    onError,
    onDone,
    headers = {},
  }
) => {
  const response = await fetch(
    URL.replace("{{escapedAgentArn}}", encodeURIComponent(ARN)),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: headers?.Authorization,
        "x-workspace-id": headers?.["x-workspace-id"],
      },
      body: JSON.stringify({
        ...params,
        headers,
        stream: true,
      }),
    }
  );

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { done, value } = await reader.read();

    if (done) {
      onDone();
      break;
    }
    buffer = decoder.decode(value, { stream: true });
    const lines = buffer.split("\n");
    buffer = lines.pop() || "";

    for (const line of lines) {
      if (line.startsWith("data: ")) {
        const data = JSON.parse(line.replace("data: ", ""));

        if (data?.error) {
          onError(data);
        }

        if (
          data?.type === EVENT_TYPE.GENERIC_EVENT &&
          data?.event?.messageStart?.role === "assistant"
        ) {
          onMessageStart?.(data);
        }

        if (data?.type === EVENT_TYPE.ON_MESSAGE_CHUNK) {
          onMessageChunk?.(data);
        } else if (data?.type === EVENT_TYPE.ON_MESSAGE) {
          onMessage?.(data);
        } else if (data?.type === EVENT_TYPE.ON_CURRENT_TOOL_USE) {
          onCurrentToolUse?.(data);
        }
      }
    }
  }
};

export default streamAIResponse;
